import { create } from 'zustand';

export type LayerId =
  | 'planets'
  | 'dwarfs'
  | 'tnos'
  | 'etnos'
  | 'planet9'
  | 'alerts';

interface LayersState {
  active: Record<LayerId, boolean>;
  toggle: (id: LayerId) => void;
  set: (id: LayerId, v: boolean) => void;
}

export const useLayers = create<LayersState>((set) => ({
  active: {
    planets: true,
    dwarfs: false,
    tnos: false,
    etnos: false,
    planet9: false,
    alerts: false,
  },
  toggle: (id) =>
    set((s) => ({ active: { ...s.active, [id]: !s.active[id] } })),
  set: (id, v) => set((s) => ({ active: { ...s.active, [id]: v } })),
}));

/** Une seule des couches petits corps activées suffit à charger le catalogue. */
export function useSmallBodiesVisible(): boolean {
  return useLayers((s) => s.active.dwarfs || s.active.tnos || s.active.etnos);
}
